import { refreshToken } from "./FetchUtil";

export const getToken = () => {
  const unparsedJwtToken = localStorage.getItem("jwtToken");
  if (!unparsedJwtToken) {
    throw new Error("No token found");
  }
  const parsedJwtToken = JSON.parse(unparsedJwtToken);
  const { token } = parsedJwtToken;
  return token;
};

export const isTokenExpiredOrInvalid = () => {
  const unparsedJwtToken = localStorage.getItem("jwtToken");
  if (!unparsedJwtToken) return true;
  const jwtToken = JSON.parse(unparsedJwtToken);

  const { expiresAt } = jwtToken;
  const tolerance_space_ms = 20000;
  return Date.now() + tolerance_space_ms > expiresAt;
};

export const tokenUsername = () => {
  const unparsedJwtToken = localStorage.getItem("jwtToken");
  if (!unparsedJwtToken) return null;
  const jwtToken = JSON.parse(unparsedJwtToken);

  const { username } = jwtToken;
  return username;
};

export const getOrRefreshToken = async () => {
  try {
    let token = getToken();
    if (isTokenExpiredOrInvalid()) {
      token = await refreshToken();
    }
    return token;
  } catch (error) {
    throw new Error("Unable to get or refresh token");
  }
};
